import { Injectable } from '@angular/core';

@Injectable()
export class ListTrackingService {
  trackById(index: number, item: any): number {
    return item.id;
  }

  trackByTimestamp(index: number, item: any): Date {
    return item.timestamp;
  }

  disableUpdate(index: number, item: any): number {
    return index;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/list-tracking.service.ts